<template>
  <div class="row">

    <div class="col-1 Slider-button" v-if="imageLsLength > 1">
      <div 
        class="ButtonIcon ButtonIcon--oval ButtonIcon--light"
        title="Previous Image"
        @click="prevImage()">
        <icon name="arrow-left" scale=".85"></icon>
      </div>
    </div>

    <div class="col-10 mx-auto">
      <div 
        class="Slider-wrapper Intrinsic-wrapper Intrinsic-wrapper--3x2" 
        :id="id"
        @mouseover="preloadImg(imageLs, parentDir)">
        <ul class="Slider-list">
          <li>
            <transition :name="transitionName" mode="in-out">

              <iframe 
              width="640" 
              height="480" 
              class="Intrinsic-item Intrinsic-item--model"
              v-if="imageLs[currentImageIndex].url"
              :src="imageLs[currentImageIndex].url"
              frameborder="0" allowvr allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe>

              <img 
                oncontextmenu="return false"
                class="Intrinsic-item"
                v-else
                @load="imgHandler"     
                @contextmenu="tooltipVisible = true"
                @mouseout="tooltipVisible = false"
                :alt="imageLs[currentImageIndex].title" 
                :class="imageLs[currentImageIndex].portait ? 'Intrinsic-item--portrait' : null"
                :src="'./static/images/' + parentDir + '/' + imageLs[currentImageIndex].fileName" 
                :key="'img-' + currentImageIndex">
            </transition>
          </li>
        </ul>
        <span class="Slider-tooltip" v-if="tooltipVisible">&copy; Jim &amp; Jamie Dutcher</span>
      </div>

      <ul class="Slider-mapDots" v-if="imageLsLength > 1">
          <li 
            class="Slider-mapDots-dot" 
            v-for="(img, i) in imageLs" 
            :key="'slider-dot-' + i"
            :class="{ 'is-active': i === currentImageIndex }"
            @click="currentImageIndex = i">
          </li>
      </ul>
    </div>

    <div class="col-1 Slider-button" v-if="imageLsLength > 1">
      <div 
        class="ButtonIcon ButtonIcon--oval ButtonIcon--light"
        title="Next Image"
        @click="nextImage()">
        <icon name="arrow-right" scale=".85"></icon>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div 
        class="col-md-8 col-xl-6 mx-auto mt-4 Blurb"
        v-if="currentImageIndex === i"
        v-for="(img, i) in imageLs"
        :key="'img-caption-' + i">
        <h2>{{ img.title }}</h2>
        <p class="Blurb-body">{{ img.caption }}</p>
      </div>
    </transition>

  </div>
</template>

<script>
import Hammer from 'hammerjs'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/arrow-up'
import MixinHelper from './../mixins/helper'
export default {
  components: {
    Icon
  },

  props: {
    id: {
      type: String,
      required: true
    },

    imageLs: {
      type: Array,
      required: true
    },

    parentDir: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      currentImageIndex: 0,
      imageLsLocal: [],
      tooltipVisible: false,
      transitionName: 'slide-right--fade',
      imageLsLength: 1
    }
  },

  watch: {
    imageLsLocal (val) {
      this.imageLsLength = val.length
    }
  },

  created () {
    window.addEventListener('keyup', this.handleKeyup)
  },

  beforeDestroy () {
    window.removeEventListener('keyup', this.handleKeyup)
  },

  mixins: [ MixinHelper ],

  methods: {
    handleKeyup (e) {
      if (e.keyCode === 37) {
        this.prevImage()
      } else if (e.keyCode === 39) {
        this.nextImage()
      }
    },

    imgHandler (e) {
      if (e.target.naturalHeight > e.target.naturalWidth) {
        e.target.className += ' ' + 'Intrinsic-item--portrait'
      }
    },

    preloadImg (imageLs, parentDir) {
      imageLs.forEach(imgObj => {
        let img = new Image()
        img.src = './static/images/' + parentDir + '/' + imgObj.fileName
      })
    },

    nextImage () {
      this.transitionName = 'slide-left--fade'
      if (this.currentImageIndex >= this.imageLs.length - 1) {
        this.currentImageIndex = 0
      } else {
        this.currentImageIndex += 1
      }
    },

    prevImage () {
      this.transitionName = 'slide-right--fade'
      if (this.currentImageIndex <= 0) {
        this.currentImageIndex = this.imageLs.length - 1
      } else {
        this.currentImageIndex -= 1
      }
    },

    swipeController (id) {
      const slider = document.getElementById(id)
      const mc = new Hammer.Manager(slider, {
        touchAction: 'pan-y'
      })
      const swipeX = new Hammer.Swipe()
      mc.add(swipeX)
      mc.on('swipeleft', () => {
        this.nextImage()
      })
      mc.on('swiperight', () => {
        this.prevImage()
      })
    }
  },

  mounted () {
    this.swipeController(this.id)
    this.imageLsLocal = this.imageLs
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.Intrinsic-item--model {
  top: -10%;
  height: 120%;
}

.Slider-button {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Slider-list {
  margin: 0 auto;
  padding: 0;
}

.Slider-mapDots {
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 1em 0 0 0;
  padding: 0;
}

.Slider-mapDots-dot {
  background: transparent;
  border: 1px solid $offwhite;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 1em;
  transition: $transitionHover;
  width: 12px;
  height: 12px;
  &.is-active {
    background-color: $gold;
    border-color: $transparentDarkgray;
  }
  &:last-child {
    margin: 0;
  }
  @media screen and (hover: hover) {
    &:hover {
      background-color: $gold;
      border-color: $transparentDarkgray;
    }
  }
}

.Slider-tooltip {
  background-color: $transparentDarkgray;
  color: $offwhite;
  font-size: .9em;
  padding: .5em 2em;
  position: absolute;
  bottom: 0;
  left: 0;
}

.Slider-wrapper {
  background-color: $transparentDarkgray;
  display: block;
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/imageSlider.vue